<template>
  <transition name="compare-popup-fade">
    <div
      v-if="visible"
      class="compare-added-popup-overlay"
      @click.self="close"
    >
      <div class="compare-added-popup" role="dialog" aria-modal="true" aria-labelledby="compare-popup-title">
        <button type="button" class="compare-added-popup__close" @click="close" aria-label="Закрити">×</button>
        <div class="compare-added-popup__badge" aria-hidden="true">⚖</div>
        <h3 id="compare-popup-title" class="compare-added-popup__title">Товар додано до порівняння</h3>
        <p v-if="productTitle" class="compare-added-popup__product">{{ productTitle }}</p>
        <p class="compare-added-popup__count">У списку {{ count }} з {{ maxItems }} товарів</p>
        <div class="compare-added-popup__actions">
          <router-link
            class="compare-added-popup__btn compare-added-popup__btn_primary"
            :to="compareRoute"
            @click.native="close"
          >
            Перейти до порівняння
          </router-link>
          <button type="button" class="compare-added-popup__btn compare-added-popup__btn_ghost" @click="close">
            Продовжити покупки
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { compareMaxItems } from '@/utils/compareList'

export default {
    name: 'compare-added-popup',
    data() {
        return {
            visible: false,
            productTitle: '',
            count: 0,
            maxItems: compareMaxItems
        }
    },
    computed: {
        compareRoute() {
            return this.$localize({ name: 'compare' })
        }
    },
    mounted() {
        window.addEventListener('compare-product-added', this.onAdded)
        window.addEventListener('keydown', this.onKeydown)
    },
    beforeDestroy() {
        window.removeEventListener('compare-product-added', this.onAdded)
        window.removeEventListener('keydown', this.onKeydown)
    },
    methods: {
        onAdded(e) {
            const d = e && e.detail ? e.detail : {}
            this.productTitle = d.product && d.product.title ? d.product.title : ''
            this.count = typeof d.count === 'number' ? d.count : 0
            this.visible = true
            document.body.classList.add('compare-popup-open')
        },
        onKeydown(e) {
            if (e.key === 'Escape' && this.visible) {
                this.close()
            }
        },
        close() {
            this.visible = false
            document.body.classList.remove('compare-popup-open')
        }
    }
}
</script>

<style src="./index.scss" lang="scss" scoped></style>
<style lang="scss">
body.compare-popup-open {
  overflow: hidden;
}
</style>
